import Perfume from 'perfume.js';

export const performance = new Perfume({
  logging: !!process.env.DEBUG,
  debugging: !!process.env.DEBUG,
});
